import { render, staticRenderFns } from "./Camerata.vue?vue&type=template&id=14bbefcf"
import script from "./Camerata.vue?vue&type=script&lang=js"
export * from "./Camerata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports